// --- Core ---
// --- SaniQ ---
import {fetchAPI} from "api";
import * as ContactConstants from "../constants/ContactForm";

function submitContactForm(values) {
  return function (dispatch) {
    dispatch(submitContactFormStarted());
    return fetchAPI('/web/v1/physicians/tickets', 'POST', values)
      .then((response) => {
        dispatch(submitContactFormCompleted());
        return response;
      }).catch(() => {
        dispatch(submitContactFormFailed());
      });
  };
}

function setOpenContactForm(open) {
  return {
    type: ContactConstants.SET_OPEN,
    open: open
  };
}

function setContactFormErrorMessage(error, eventId) {
  return {
    type: ContactConstants.SET_ERROR,
    error_message: error,
    eventId: eventId
  };
}

function submitContactFormStarted() {
  return {
    type: ContactConstants.SEND_CONTACTFORM_STARTED
  };
}

function submitContactFormCompleted() {
  return {
    type: ContactConstants.SEND_CONTACTFORM_COMPLETED
  };
}

function submitContactFormFailed() {
  return {
    type: ContactConstants.SEND_CONTACTFORM_FAILED
  };
}

export {
  submitContactForm,
  setOpenContactForm,
  setContactFormErrorMessage
};
